<template>
    <div class="content-wrapper">
        <div id="overlay" v-if="processingAPI">
            <div class="spinner"></div>
            <span class="text-center badge bg-green fs-14" style="margin-top:110px;">Processing...</span>
        </div>
        <div id="overlay" v-if="uploadingAPI">
            <div class="spinner"></div>
            <span class="text-center badge bg-green fs-14" style="margin-top:110px;">Uploading...</span>
        </div>



        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-6">
                        <h1>
                            Dashboard
                        </h1>
                    </div>
                </div>
            </div>
        </div>



        <div class="content" >
            <div class="content-fluid">
                <div class="row" v-show="!notif_id && !borrower_id && !application_id">
                    <div class="col-12">
                        <div class="card mb-0" style="border-radius: 0 !important;">
                            <div class="card-header">
                                <h3 class="card-title bold">Notification<sup class="ml-1 badge badge-danger fs-12" v-if="notif.length > 0">{{notif.length}}</sup></h3>
                                <div class="card-tools">
                                    <button type="button" class="pointer primary btn btn-tool" @click="toggling('AR')">
                                        <i :class="[ toggle.AR ? 'fas fa-chevron-down' : 'fas fa-chevron-left' ]"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body" v-show="toggle.AR">
                                <div class="table-responsive" v-if="notif.length > 0">
                                    <table class="table table-sm">
                                        <thead>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Action</th>

                                        </thead>
                                        <tbody>
                                            <tr v-for="n in notif" :key="n.id">
                                                <td>{{n.created_at | datetime}}</td>
                                                <td>{{n.subject}}</td>
                                                <td>
                                                    <button class="btn btn-sm btn-primary" @click="notifURL(n)">View</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="alert alert-info2" v-else>
                                    <i class="fas fa-info-circle mr-1 fs-15"></i>No available notification.
                                </div>
                            </div>
                        </div>
                        <div class="card mb-0" style="border-radius: 0 !important;">
                            <div class="card-header">
                                <h3 class="card-title bold">Transaction History</h3>
                                <div class="card-tools">
                                    <button type="button" class="pointer primary btn btn-tool" @click="toggling('TH')">
                                        <i :class="[ toggle.TH ? 'fas fa-chevron-down' : 'fas fa-chevron-left' ]"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body" v-show="toggle.TH">
                                <div class="table-responsive" v-if="transact.length > 0">
                                    <table class="table table-sm">
                                        <thead>
                                            <th>Date</th>
                                            <th>Description</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="n in transact" :key="n.id">
                                                <td>{{n.created_at | datetime}}</td>
                                                <td>{{n.details}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="alert alert-warning2" v-else>
                                    <i class="fas fa-info-circle mr-1 fs-15"></i>Not available at the moment.
                                </div>
                            </div>
                        </div>



                        <div class="card mb-0" style="border-radius: 0 !important;" v-if="lr_attach.length > 0">
                            <div class="card-header">
                                <h3 class="card-title bold">Loan Releasing Documents</h3>
                                <div class="card-tools">
                                    <button type="button" class="pointer primary btn btn-tool" @click="toggling('LR')">
                                        <i :class="[ toggle.LR ? 'fas fa-chevron-down' : 'fas fa-chevron-left' ]"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body" v-show="toggle.LR">
                                <div class="table-responsive" >
                                    <table class="table table-sm">
                                        <thead>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Action</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="lr in lr_attach" :key="lr.id">
                                                <td>{{lr.updated_at | datetime}}</td>
                                                <td>{{lr.attach_desc}}</td>
                                                <td> 
                                                    <button class="btn btn-sm btn-primary" @click="lrURL(lr.filepath, lr.attach)"><i class="fas fa-download mr-1"></i>Download</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <div class="alert alert-warning2" v-else>
                                    <i class="fas fa-info-circle mr-1 fs-15"></i>Not available at the moment.
                                </div> -->
                            </div>
                        </div>

                    </div>
                </div>
                <div class="row" v-show="notif_id && borrower_id && application_id && !update_profile">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title bold">For Compliance</h3>
                            </div>
                            <div class="card-body">
                                <div class="alert alert-info2 text-justify">
                                    <i class="fas fa-info-circle mr-1 fs-15"></i>Please click the "View" button to see the requirements for each document.
                                </div>

                                <div class="table-responsive">
                                    <table class="table table-sm">
                                        <thead>
                                            <th style="min-width: 200px!important;">Criteria</th>
                                            <th>Details</th>
                                            <th style="min-width: 250px!important;">Reason/s</th>
                                            <th>Status</th>
                                            <th style="min-width: 200px !important; max-width: 300px !important;">Action</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="n in notif_detail" :key="n.id">
                                                <td>{{n.doc_desc}}</td>
                                                <td>
                                                    <button class="btn btn-outline-primary btn-sm" @click="showDetails(n.attach_code)">View</button>
                                                </td>
                                                <td>{{n.reason_desc}}</td>
                                                <td>
                                                    <span v-if="n.status == 'CS01'" class="badge badge-primary">For Compliance</span>
                                                    <span v-else class="badge badge-success">Complied</span>
                                                </td>
                                                <td>
                                                    <div v-if="n.type==2">
                                                        <div v-if="n.status == 'CS01'" class="text-center">
                                                            <div class="input-group">
                                                                <input type="text" class="form-control form-control-sm ro" @click="browseRef(n.attach_code)" readonly v-model="labelATT[n.attach_code]">
                                                                <input type="file" v-if="n.attach_code =='ATT26' || n.attach_code =='ATT27' || n.attach_code =='ATT28'" hidden :id="n.attach_code" @change="uploadVideo($event, formATT, n.attach_code)">
                                                                <input type="file" v-else hidden :id="n.attach_code" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, n.attach_code)">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-outline-primary" @click="browseRef(n.attach_code)">Browse</button>
                                                                    <button v-show="formATT[n.attach_code]" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT[n.attach_code], n.doc_desc)">View</button>
                                                                </div>
                                                            </div>
                                                            <div v-if="progress[n.attach_code]">
                                                                <div class="progress">
                                                                    <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress[n.attach_code]+ ';'">
                                                                        {{progress[n.attach_code]}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <i v-else class="fas fa-check success fs-20"></i>
                                                    </div>
                                                    <div v-else>
                                                        <button v-if="n.status == 'CS01'" class="btn btn-outline-primary btn-sm" @click="editModal(n.attach_code)"><i class="fas fa-edit mr-1"></i>Edit</button>
                                                        <i v-else class="fas fa-check success fs-20"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="card-footer">
                                <button class="btn btn-outline-primary" @click="routeBack"><i class="fas fa-arrow-left mr-1"></i></i>Back</button>
                                <button class="btn btn-success float-right" @click="submitTag">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                                <!-- <button class="btn btn-primary float-right mr-2" @click="saveTag"><i class="fas fa-save mr-1"></i>Save</button> -->
                            </div>
                        </div>
                    </div>

                </div>



                <div class="row" v-if="notif_id && borrower_id && application_id && update_profile">
                    <div class="col-md-1"></div>
                    <div class="col-md-10">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title bold">Update Profile</h3>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>First Name</label>
                                            <input class="form-control form-control-sm text-uppercase" type="text"  v-model.trim="formName.fname" @input="formName.fname=$event.target.value.toUpperCase().trim()" 
                                            @keypress="isName($event)"  :class="{ 'is-invalid': submiitedProfile && $v.formName.fname.$error }">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Middle Name</label>
                                            <input class="form-control form-control-sm text-uppercase" type="text" v-model.trim="formName.mname" @input="formName.mname=$event.target.value.toUpperCase().trim()" 
                                            @keypress="isName($event)"  :class="{ 'is-invalid': submiitedProfile && $v.formName.mname.$error }">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Last Name</label>
                                            <input class="form-control form-control-sm text-uppercase" type="text" v-model.trim="formName.lname" @input="formName.lname=$event.target.value.toUpperCase().trim()" 
                                            @keypress="isName($event)" :class="{ 'is-invalid': submiitedProfile && $v.formName.lname.$error }">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Suffix</label>
                                            <select class="custom-select-sm form-control text-uppercase" v-model='formName.suffix_code'>
                                                <option :value="null" selected>- Select -</option>
                                                <option value="2020001">I</option>
                                                <option value="2020002">II</option>
                                                <option value="2020003">III</option>
                                                <option value="2020004">SR.</option>
                                                <option value="2020005">JR.</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Birth Date</label>
                                            <date-range-picker autocomplete="off" id="bdate" v-model="formName.date_birth" class="form-control form-control-sm" :start-date="date_birth" :max-date="maxBdate" :min-date="minBdate" v-input-mask data-inputmask-alias="datetime" 
                                            :data-inputmask-max="maxBdate" :data-inputmask-min="minBdate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy" :class="{ 'is-invalid': submiitedProfile && $v.formName.date_birth.$error }"></date-range-picker>
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Sex</label>
                                            <select class="form-control custom-select-sm"  v-model='formName.gender_id' :class="{ 'is-invalid': submiitedProfile && $v.formName.gender_id.$error }">
                                                <option selected disabled :value='null'>- Select -</option>
                                                <option value="G202001">Male</option>
                                                <option value="G202002">Female</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Civil Status</label>
                                            <select class="form-control custom-select-sm text-uppercase" v-model='formName.cs_code' :class="{ 'is-invalid': submiitedProfile && $v.formName.cs_code.$error }">
                                                <option selected disabled :value='null'>- Select -</option>
                                                <option value="CS001">Single</option>
                                                <option value="CS002">Married</option>
                                                <option value="CS003">Widowed</option>
                                                <option value="CS004">Separated</option>
                                                <option value="CS006">Annulled</option>
                                            </select>
                                        </div>

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Place of Birth <em>(Province)</em></label>
                                            <v-select label="province"  :options="provinces" :reduce="province => province.province_code" v-model="formName.province_code_birth" 
                                                    :clearable="false" @input="getCity(formName.province_code_birth), formName.place_birth=''"></v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label><em>(City)</em></label>
                                            <v-select label="city" :options="cities" :reduce="city => city.city_code" v-model="formName.place_birth" :clearable="false"></v-select>
                                        </div>
                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Goverment Issued I.D.</label>
                                            <v-select label="id_name" :options="data_IDtypes" :reduce="id_name => id_name.id_code" :clearable="false" v-model="formName.id_code" :class="{'vs-invalid': submiitedProfile && $v.formName.id_code.$error }">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>I.D. Number</label>
                                            <input type="text" class="form-control form-control-sm text-uppercase"@input="formName.id_number=$event.target.value.toUpperCase().trim()"  v-model.trim="formName.id_number" :class="{ 'is-invalid': submiitedProfile && $v.formName.id_number.$error }">
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Expiry Date</label>
                                            <date-range-picker autocomplete="off" id="id_issuedate" v-model="formName.expiry_date" class="form-control form-control-sm" :max-date="maxExpiry" :min-date="minExpiry" :start-date="today" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxExpiry" :data-inputmask-min="minExpiry" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="alert alert-info2 text-justify">
                                            <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>
                                            <span class="text-justify fs-15">Only accepts <b>png, jpg, jpeg file format</b>. If you’re using a computer or a laptop, you may only upload an existing photo. If you’re using your mobile phone/tablet/IPAD, you may either upload an existing photo or capture a new photo.</span>
                                        </div>
                                        <div class="attachment-block clearfix">
                                            <div class="text-center">
                                                <img :src="formName.ATT12" class="img-fluid" style="max-height: 300px!important; min-height:250px!important;" v-if="formName.ATT12">
                                                <img class="img-fluid" src="images/image_placeholder.jpg" v-else>
                                                <div v-show="submiitedProfile && $v.formName.ATT12.$error " class="danger fs-13">Required</div>
                                            </div>

                                        </div>
                                        <div class="text-center">
                                            <label class="btn btn-sm btn-primary nowrap pointer mb0">
                                                Browse/Capture
                                                <input type="file" hidden @change="uploadImage12" accept=".png, .jpg, .jpeg">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-footer">
                                <button class="btn btn-outline-primary" @click="routeBack2"><i class="fas fa-arrow-left mr-1"></i></i>Back</button>
                                <button class="btn btn-success float-right" @click="updateNameID">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1"></div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="modalProfile" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">DUPLICATE RECORD/S EXIST/S</h5>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-danger text-justify">
                        Our system has detected that there is/are existing record/s under this name. Kindly check and take note of the EMAIL ADDRESS with the CORRECT NAME.  You will be logged out from the system and you would need to login using the email address you have selected.
                        </div>

                        <div class="table-responsive">
                            <table class="table table-sm table-bordered">
                                <thead>
                                    <th>Email</th>
                                    <th>Name</th>
                                    <th>Birthdate</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(u, index) in duplicates" :key="u.user_id">
                                        <td class="nowrap">{{u.email}}</td>
                                        <td class="nowrap">
                                            <span v-if="u.suffix_desc">{{u.fname + ' ' + u.mname + ' ' + u.lname + ' ' + u.suffix_desc}}</span>
                                            <span v-else>{{u.fname + ' ' + u.mname + ' ' + u.lname}}</span>
                                        </td>
                                        <td class="nowrap">{{u.date_birth | MM/DD/YYYY}}</td>
                                        <td class="nowrap">
                                            <span v-if="u.user_id == user.id" class="badge badge-success">Currently logged in</span>
                                            <span v-else class="badge badge-primary">Active</span>
                                        </td>
                                        <td class="nowrap">
                                            <div class="icheck-primary">
                                                <input type="checkbox" v-bind:id="u.user_id" v-model="selectedAccount" :value="u" @change="selectedRow(u.user_id)" :disabled="selectedAccount.length >= 1 && u.user_id != selectedAccount[0].user_id">
                                                <label  v-bind:for="u.user_id"></label>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary" @click="updateAccount">Update</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="modalBank" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Update Bank Details</h5>
                    </div>
                    <div class="modal-body">


                        <div class="form-group">
                            <label>Manner of Release</label>
                            <select ref="manner_rel" class="form-control custom-select-sm" @change="selectedMR" v-model="formBank.manner_rel" :class="{'is-invalid': submittedBank && $v.formBank.manner_rel.$error}">
                                <option :value="null" disabled selected>- Please Select -</option>
                                <option v-for="data in filteredMR" :key="data.manner_rel_code" :value="data.manner_rel_code">{{data.manner_rel_desc}}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="formBank.manner_rel !='GC' && formBank.manner_rel !='PM'">
                            <label>Bankname</label>
                            <v-select label="bankname" :class="{'vs-invalid': submittedBank && $v.formBank.bankname.$error }" :options="filteredBank" :reduce="bankname => bankname.bankname" :clearable="false" v-model="formBank.bankname"></v-select>
                        </div>
                        <div class="form-group">
                            <label>Account Name</label>
                            <input type="text" class="form-control form-control-sm text-uppercase" v-model="formBank.acctname" :disabled="formBank.bt_code!='BT2020001'" :class="{'is-invalid': submittedBank && $v.formBank.acctname.$error}">
                        </div>
                        <div class="form-group">

                            <div v-if="formBank.manner_rel =='GC' || formBank.manner_rel =='PM'">
                                <label>Registered Mobile Number</label>
                                <input type="text" ref="acctno" class="form-control form-control-sm text-uppercase" v-model="formBank.acctno" v-input-mask data-inputmask-mask="(9999) 9999999" data-inputmask-placeholder="" :class="{ 'is-invalid': submittedBank && $v.formBank.acctno.$error }">
                                <em class="fs-13">Ex. (0912) 3456789</em>
                                <p class="fs-13 danger m-0 p-0" v-if="submittedBank && $v.formBank.acctno.$error">Not a valid Mobile Number</p>
                            </div>
                            <div v-else>
                                <label>Account Number</label>
                                <input type="text" ref="acctno" class="form-control form-control-sm text-uppercase" v-model="formBank.acctno" @input="unmaskAcctNo" :class="{ 'is-invalid': submittedBank && $v.formBank.acctno.$error }">
                                <!-- <div v-show="formBank.manner_rel == 'FT' && formBank.bankname == 'LAND BANK OF THE PHILIPPINES' && checkAcctNo.charAt(3) != '6' &&  checkAcctNo.charAt(3) != '7'" class="danger fs-13"><em>For Fund Transfer (Landbank) – Account number should have 6 or 7 on the fourth digit of the account number</em></div> -->
                            </div>
                        </div>

                        <hr>
                        <div class="form-group">
                            <p class="card-text text-justify fs-15"><em>Please upload here an evidence of your account name and number (e.g. screenshots from online apps, bank-validated deposit slip, ATM card with account name and account number, Passbook, etc.)</em></p>
                            <div class="input-group">
                                <input type="text" class="form-control form-control-sm ro" @click="browseRef('ATT22')" readonly v-model="labelATT.ATT22" :class="{'is-invalid': submittedBank && !formATT.ATT22}">
                                <input type="file" hidden id="ATT22" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, 'ATT22')">
                                <div class="input-group-append">
                                    <button class="btn btn-sm btn-outline-primary" @click="browseRef('ATT22')">Browse</button>
                                    <button v-show="formATT.ATT22" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT.ATT22, 'Proof of Bank/EMA')">View</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary" @click="updateBankDet">Update</button>
                    </div>
                </div>
            </div>
        </div>





        <div class="modal fade" id="modalCob" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Update Coborrower</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>First Name</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.fname" @input="formCob.fname=$event.target.value.toUpperCase().trim()"
                                    :class="{ 'is-invalid': submittedCob && $v.formCob.fname.$error }">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Middlename</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.mname" @input="formCob.mname=$event.target.value.toUpperCase().trim()"
                                    :class="{ 'is-invalid': submittedCob && $v.formCob.mname.$error }">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Lastname</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.lname" @input="formCob.lname=$event.target.value.toUpperCase().trim()"
                                    :class="{ 'is-invalid': submittedCob && $v.formCob.lname.$error }">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Suffix</label>
                                    <select class="form-control custom-select-sm text-uppercase" v-model="formCob.suffix_code">
                                        <option :value="null" selected>- Select -</option>
                                        <option value="2020001">I</option>
                                        <option value="2020002">II</option>
                                        <option value="2020003">III</option>
                                        <option value="2020004">SR.</option>
                                        <option value="2020005">JR.</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="">Relationship to the Borrower</label>
                                    <select class="form-control custom-select custom-select-sm text-uppercase" v-model="formCob.relation_code" :class="{ 'is-invalid': submittedCob && $v.formCob.relation_code.$error }">
                                        <option :value="null" selected disabled>- Select -</option>
                                        <option v-for="data in data_relation" :key="data.relation_code" :value="data.relation_code">{{data.relation_desc}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Government-Issued ID</label>
                                    <v-select label="id_name" :class="{'vs-invalid': submittedCob && $v.formCob.id_code.$error }" :options="data_IDtypes" v-model="formCob.id_code" :reduce="id_name => id_name.id_code" :clearable="false">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">ID Number</label>
                                    <input type="text" class="form-control form-control-sm" v-model.trim="formCob.id_number" :class="{ 'is-invalid': submittedCob && $v.formCob.id_number.$error }">
                                </div>
                            </div>
                        </div>


                        <hr>
                        <div class="form-group">
                            <div class="alert alert-warning2">
                                <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>Only accepts png, jpg, jpeg and pdf file format.
                            </div>
                            <p class="card-text text-justify fs-15">Upload Co-borrower Government-Issued ID</p>
                            <div class="input-group">
                                <input type="text" class="form-control form-control-sm ro" @click="browseRef('ATT29')" readonly v-model="labelATT.ATT29" :class="{'is-invalid': submittedCob && !formATT.ATT29}">
                                <input type="file" hidden id="ATT29" accept=".png, .jpg, .jpeg, .pdf" @change="uploadImgPdf($event, formATT, 'ATT29')">
                                <div class="input-group-append">
                                    <button class="btn btn-sm btn-outline-primary" @click="browseRef('ATT29')">Browse</button>
                                    <button v-show="formATT.ATT29" type="button" class="btn btn-sm btn-outline-success" @click="viewATT(formATT.ATT29, 'Coborrower Gov. ID')">View</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary" @click="updateCob">Update</button>
                    </div>
                </div>
            </div>
        </div>




        <div class="modal fade" id="modalGuide" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold" v-if="guides2">{{guides2.title}}</h5>
                    </div>
                    <div class="modal-body">
                        <ul>
                            <li v-for="i in guides2.contents">{{i.label}}</li>
                        </ul>
                        <a v-if="guides2.code=='DOC01'" href="templatedFILE/Affidavit of Denial Template.docx" download>Download Affidavit of Denial Template</a>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="modalAppForm" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Loan Application Form</h5>
                    </div>
                    <div class="modal-body">
                        <object :data="appForm.filepath + appForm.attach + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="" width="100%" height="100%">
                            <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                            <center><a :href="appForm.filepath + appForm.attach" class="btn btn-sm btn-primary"><i class="fas fa-download mr-1"></i>Download File</a></center>
                            <br>
                        </object>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalBusiness" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Update Business Information</h5>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Business Name</label>
                            <input type="text" class="form-control form-control-sm text-uppercase" v-model="bus_info.business_name" :class="{ 'is-invalid': submittedBusName && $v.bus_info.business_name.$error }">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                        <button class="btn btn-primary" @click="updateBusName">Update</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import moment from 'moment'
    import {
        Form
    } from 'vform';
    import {
        required,
        requiredIf,
    } from "vuelidate/lib/validators";
    export default {
        data() {
            return {
                today: moment().format('MM/DD/YYYY'),
                maxExpiry: '12/31/2040',
                minExpiry: '01/01/2000',
                minBdate: moment('01/01/1920', 'MM/DD/YYYY'),
                maxBdate: moment().subtract(18, 'years').format('MM/DD/YYYY'),
                date_birth: moment('01/01/1920', 'MM/DD/YYYY'),
                // date_birth: null,

                duplicates:[],
                selectedAccount:[],
                ids:[],
                ids2:[],

                guides2: [],
                guides: [{
                        code: 'ATT12',
                        title: 'Government-issued ID',
                        contents: [{
                                label: 'Must be a valid government-issued ID'
                            },
                            {
                                label: 'Name in the ID must match the name in the application (first, middle and last name)'
                            },
                            {
                                label: 'Applicant must be the business owner or the President/CEO for Corporations'
                            },
                            {
                                label: 'Picture of the ID must be clear and readable'
                            },
                        ]
                    },
                    {
                        code: 'ATT22',
                        title: 'Proof of Bank/EMA Account',
                        contents: [{
                                label: 'Document must clearly reflect the complete account number and name and the bank name'
                            },
                            {
                                label: 'Complete account number must be entered in the account number field (including zero/es)'
                            },
                            {
                                label: 'Bank/EMA Account must be under the name of the borrower for Sole Proprietor or name of the business for Corporation/Partnership'
                            },
                            {
                                label: 'GCASH/Paymaya accounts must be fully verified'
                            },
                        ]
                    },
                    {
                        code: 'ATT26',
                        title: 'Video',
                        contents: [{
                                label: '1-minute video for products and services'
                            },
                            {
                                label: 'Size of the video file (mp4 format) must not exceed 110mb'
                            },
                        ]
                    },
                    {
                        code: 'ATT27',
                        title: 'Video',
                        contents: [{
                                label: '1-minute video for buyers and suppliers and monthly or annual sales'
                            },
                            {
                                label: 'Size of the video file (mp4 format) must not exceed 110mb'
                            },
                        ]
                    },
                    {
                        code: 'ATT28',
                        title: 'Video',
                        contents: [{
                                label: '1-minute video for number and work assignments of employees'
                            },
                            {
                                label: 'Size of the video file (mp4 format) must not exceed 110mb'
                            },
                        ]
                    },
                    {
                        code: 'DOC01',
                        title: 'Credit Checking Findings',
                        contents: [{
                                label: 'For the list of unresolved credit dealings, please refer to the email advice sent by the Credit Standing Assessment Team to your verified email address.'
                            },
                            {
                                label: 'For multiple submission/documents, kindly compile all documents into one PDF file before uploading.'
                            }
                        ]
                    },
                   
                ],

                appForm: new Form({
                    attach: null,
                    filepath: null,
                }),

                submittedCob: false,
                formCob: new Form({
                    application_id: null,
                    borrower_id: null,
                    fname: null,
                    lname: null,
                    mname: null,
                    notif_id: null,
                    suffix_code:null,
                    relation_code:null,
                    id_code:null,
                    id_number:null,
                    ATT29: null,
                }),


                submittedBank: false,
                checkAcctNo: '',
                formBank: new Form({
                    application_id: null,
                    req_loan_amt: null,
                    manner_rel: null,
                    bankname: null,
                    acctname: null,
                    acctno: null,
                    ATT22: null,
                    notif_id: null,
                    bt_code:null,
                }),



                recordExist: false,
                submiitedProfile: false,

                submittedBusName: false,

                formName: new Form({
                    borrower_id: null,
                    notif_id: null,
                    application_id: null,

                    user_id: null,
                    fname: null,
                    lname: null,
                    mname: null,
                    suffix_code: null,
                    date_birth: null,
                    email: null,

                    province_code_birth: null,
                    place_birth: null, //city_code

                    gender_id: null,
                    cs_code: null,

                    s_birthdate: null,
                    bt_code: null,

                    id_code: null,
                    id_number: null,
                    expiry_date: null,
                    s_expiry_date: null,
                    ATT12: null,
                }),

                uploadRRF: false,
                fileImage: ['image/jpeg', 'image/png', 'image/jpg', 'image/JPEG', 'image/PNG', 'image/JPG'],
                fileImagePdf: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'image/JPEG', 'image/PNG', 'image/JPG', 'application/PDF'],
                fileVideo: ['video/MOV', 'video/mov', 'video/MPEG4', 'video/mpeg4', 'video/MP4', 'video/mp4', 'video/AVI', 'video/avi',
                    'video/WMV', 'video/wmv', 'video/MPEGPS', 'video/mpegps', 'video/FLV', 'video/flv', 'video/3GPP', 'video/3ggp', 'video/3GP', 'video/3gp', 'video/HEVC',
                    'video/hevc', 'video/WebM', 'video/wbem', 'video/DNxHR', 'video/dnxhr', 'video/ProRes', 'video/prores', 'video/CineForm', 'video/cineform'
                ],
                fileSizeVideo: 1024 * 1024 * 110,
                upload: {
                    

                    ATT12: false,
                    ATT22: false,
                    ATT26: false,
                    ATT27: false,
                    ATT28: false,
                    DOC01: false,

                },
                progress: {
                    ATT12: 0,
                    ATT22: 0,
                    ATT26: 0,
                    ATT27: 0,
                    ATT28: 0,
                    DOC01: 0,
                },

                labelATT: {
                    ATT12: 'Choose a file...',
                    ATT22: 'Choose a file...',
                    ATT26: 'Choose a file...',
                    ATT27: 'Choose a file...',
                    ATT28: 'Choose a file...',
                    DOC01: 'Choose a file...',
                },

                formATT: {
                    ATT12: null,
                    ATT22: null,
                    ATT26: null,
                    ATT27: null,
                    ATT28: null,
                    DOC01: null,
                    
                },


                fetchATT: {

                    ATT12: null,
                    ATT22: null,
                    ATT26: null,
                    ATT27: null,
                    ATT28: null,
                    DOC01: null,
                    
                },


                notif_id: this.$route.query.n,
                borrower_id: this.$route.query.b,
                application_id: this.$route.query.a,
                update_profile: this.$route.query.update,

                notif: [],
                notif_detail: [],
                transact: [],
                data_manner_rel: [],
                data_banks: [],
                data_IDtypes: [],
                bus_info: {
                    business_name:null,
                    id: null,
                    bt_code:null,
                },
                business_file: null,
                doc_code: null,
                exist_loan: null,
                for_settlement: false,

                provinces: [],
                cities: [],



                data_relation:[],

                formBorrower: new Form({
                    user_id: null,
                    borrower_id: null,
                    fname: null,
                    lname: null,
                    mname: null,
                    suffix_code: null,
                    suffix_desc: null,
                    date_birth: null,
                    email: null,

                    province_code_birth: null,
                    place_birth: null, //city_code

                    gender_id: null,
                    cs_code: null,

                    s_birthdate: null,
                }),

                bt_code:null,


                lr_attach: [],

                user: new Form({
                    id: null,
                    firstname: null,
                    lastname: null,
                    birthdate: null,
                    bus_type: null,
                    suffix_code: null,
                    domain: null,
                }),


                toggle: {
                    AR: false,
                    TH: false,
                    LR:false,
                },

                api: {
                    preReg: false,
                    bor_det: false,
                    user: false,
                    notif: false,
                    bank: false,
                    update_profile: false,
                    cob: false,
                    update: false,
                    transact: false,
                    form: false,
                    id_types: false,
                    city:false,
                    prov:false,
                    lr:false,
                },

                remain_detail:[],
                filePDF: ['application/pdf', 'application/PDF'],
                fileImage:['image/jpeg', 'image/png', 'image/jpg', 'image/JPEG', 'image/PNG', 'image/JPG'],

            } //return
        }, //data
        validations: {
            formBank: {
                manner_rel: {
                    required
                },
                bankname: {
                    required: requiredIf(function() {
                        return this.formBank.manner_rel == 'FT' || this.formBank.manner_rel == 'IP' || this.formBank.manner_rel == 'PN';
                    })
                },
                acctname: {
                    required
                },
                acctno: {
                    required
                },
                ATT22: {
                    required
                },

            },
            formCob: {
                fname: {
                    required
                },
                mname: {
                    required
                },
                lname: {
                    required
                },
                relation_code: {
                    required
                },
                id_code: {
                    required
                },
                id_number: {    
                    required
                },
                ATT29: {    
                    required
                },
            },
            formName: {
                fname: {
                    required
                },
                mname: {
                    required
                },
                lname: {
                    required
                },
                date_birth:{
                    required
                },
                gender_id:{
                    required
                },
                cs_code:{
                    required
                },
                id_code: {
                    required
                },
                id_number: {
                    required
                },
                ATT12: {
                    required
                },
            },
            bus_info: {
                business_name: {
                    required
                },
            },
        },

        methods: {

            lrURL(path, file){
                    this.api.lr = true;
                    axios.get('api/c3-dl-attach-lr', {
                        params: {
                            path: path,
                            file: file
                        },
                        responseType: 'blob'
                    })
                    .then(response => {
                        this.api.lr = false;
                        if(response.status == 204)
                        {
                            Swal.fire({
                                icon: 'warning',
                                title: 'File Not Found',
                                // text: 'File Not Found',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            })
                        }
                        else
                        {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', file);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            window.URL.revokeObjectURL(url);
                        }

                    })
                    .catch((error) => {
                        this.api.lr = false;
                        console.log(error);
                    })
            },

            getAttachLR(borrower_id) {
                    this.api.lr = true;
                    axios.get('api/c3-attach-lr', {
                        params: {
                            borrower_id: borrower_id
                        }
                    })
                    .then(response => {
                        this.api.lr = false;
                        this.lr_attach = response.data;
                    })
                    .catch((error) => {
                        this.api.lr = false;
                        console.log(error);
                    })
            },


            updateAccount(){

                Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'No',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                    }).then((result) => {

                        this.api.user = true;
                        axios.post('api/db-update-user', {
                            accounts: this.remain_detail,
                            selected_id: this.selectedAccount[0].user_id,
                            selected_bor_id: this.selectedAccount[0].borrower_id,
                            selected_email: this.selectedAccount[0].email,
                            borrower_id: this.borrower_id
                        })
                        .then((response) => {
                            this.api.user = false;
                            
                                if (this.formName.expiry_date) {
                                    let customDate = moment(this.formName.expiry_date, 'MM/DD/YYYY');
                                    this.formName.s_expiry_date = customDate.format('YYYY-MM-DD');
                                }

                                if (this.formName.date_birth) {
                                    let customDate = moment(this.formName.date_birth, 'MM/DD/YYYY');
                                    this.formName.s_birthdate = customDate.format('YYYY-MM-DD');
                                }

                                setTimeout(() => {
                                    this.updateProfile2();
                                }, 700);

                           
                        })
                        .catch(error => {
                            this.api.user = false;
                            console.log(error);
                        })
                    })

            },

            selectedRow(e){
                if(this.selectedAccount.length > 0){
                    this.remain_detail = JSON.parse(JSON.stringify(this.duplicates));
                    this.remain_detail = this.remain_detail.filter(function(val){ 
                        return val.user_id !== e;
                    });
                }else{
                    this.remain_detail = []; 
                }
            },


            isName(e) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                if(/^[A-Za-z Ññ.'\-]+$/.test(char))
                {
                    return true; // Match with regex 
                }
                else e.preventDefault(); // If not match, don't add to input text
            },

            getCity(val) {
                if(val){
                    this.api.city = true;
                    axios.get('api/ref-prov-cities', {
                        params: {
                            province_code: val
                        }
                    })
                    .then(response => {
                        this.api.city = false;
                        this.cities = response.data;
                    })
                    .catch((error) => {
                        this.api.city = false;
                        console.log(error);
                    })
                }
            },

            getProvince() {
                if(this.provinces.length == 0){
                    this.api.prov = true;
                    axios.get('/api/ref-provinces')
                        .then(response => {
                            this.api.prov = false;
                            this.provinces = response.data
                        })
                        .catch(error => {
                            this.api.prov = false;
                            console.log(error);
                        })
                }
            },

            getExistLoan() {
                axios
                    .get("api/exist-loan")
                    .then(response => {
                        this.exist_loan = response.data
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            showDetails(e) {

                this.guides2 = this.guides.find(i => i.code === e);
                setTimeout(() => {
                    $('#modalGuide').modal('show');
                }, 300);

            },


            ///////
            goApplyLoan() {
                this.$router.push('/apply-loan');
            },

            goProfile() {
                this.$router.push('/profile');
            },

            initToggling() {
                if (this.notif.length > 0) {
                    this.toggle.AR = true;
                    this.toggle.TH = false;
                } else {
                    this.toggle.AR = false;
                    this.toggle.TH = true;
                }
            },

            toggling(key) {
                let obj = this.toggle;
                for (let k in obj) {
                    obj[k] == obj[key] ? obj[k] = obj[key] : obj[k] = false
                }
                obj[key] = !obj[key];
            },

            requiredField() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation',
                    text: 'Please fill-out all required fields',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            },

            invalidFileFormat() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'You are uploading unsupported file format',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },

            viewATT(formATT, title) {
                if (formATT) {
                    this.viewSelectedFile(formATT, title);
                }
            },

            viewSelectedFile(file, filename) {
                if (file['type'] == 'application/pdf') {
                    let win = open('', '', "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes");
                    let iframe = document.createElement('iframe');
                    let title = document.createElement('title');
                    let fileUrl = window.URL.createObjectURL(file);

                    title.appendChild(document.createTextNode(filename));

                    iframe.src = fileUrl;
                    iframe.width = '100%';
                    iframe.height = '100%';
                    iframe.style.border = 'none';

                    win.document.head.appendChild(title);
                    win.document.body.appendChild(iframe);
                    win.document.body.style.margin = 0;
                } else {
                    let fileURL = window.URL.createObjectURL(file);
                    let winFeatures = "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes";
                    let win = window.open(fileURL, filename, winFeatures);

                    win.onload = (event) => {
                        setTimeout(() => win.document.title = filename, 300);
                    };
                }


            },

            setStatusATT(key) {
                let objectIndex = this.notif_detail.findIndex((obj => obj.attach_code == key))
                this.notif_detail[objectIndex].status = "CS02";
            },
            resetStatusATT(key) {
                let objectIndex = this.notif_detail.findIndex((obj => obj.attach_code == key))
                this.notif_detail[objectIndex].status = "CS01";
            },
            trimFilename(n, len) {
                let ext = n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase();
                let filename = n.replace('.' + ext, '');
                if (filename.length <= len) {
                    return n;
                }
                filename = filename.substr(0, len) + (n.length > len ? '[...]' : '');
                return filename + '.' + ext;
            },
            invalidFileSizeVideo() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'Exceeded the maximum file size required in Video which is 110MB only',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },

            uploadVideo($event, formObj, key) {
                let file = $event.target.files[0];
                let size = 1024 * 1024 * 110;
                if (file) {
                    if (this.fileVideo.includes(file['type'])) {

                        if (file['size'] > size) {
                            this.invalidFileSizeVideo();
                            formObj[key] = null;
                            this.labelATT[key] = 'Choose a file...';
                        } else {
                            this.progress[key] = 0;
                            formObj[key] = file;
                            this.labelATT[key] = this.trimFilename(file.name, 8);
                            this.resetStatusATT(key)
                        }
                    } else {
                        this.invalidFileFormat();
                        formObj[key] = null;
                        this.labelATT[key] = 'Choose a file...';
                    }
                } else {
                    formObj[key] = formObj[key];
                    this.labelATT[key] = this.labelATT[key];
                }
            },

            uploadImgPdf($event, formObj, key) {

                let file = $event.target.files[0];
                if (file) {
                    if (this.fileImagePdf.includes(file['type'])) {
                        this.progress[key] = 0;
                        formObj[key] = file;
                        this.labelATT[key] = this.trimFilename(file.name, 8);
                        this.resetStatusATT(key)
                    } else {
                        this.invalidFileFormat();
                        formObj[key] = null;
                        this.labelATT[key] = 'Choose a file...';
                    }
                } else {
                    formObj[key] = formObj[key];
                    this.labelATT[key] = this.labelATT[key];
                }


            },
            browseRef(id) {
                document.getElementById(id).click();
            },

            unmaskAcctNo() {
                let val = this.formBank.acctno;
                this.checkAcctNo = val.replace(/-|\s/g, "");
            },



            submitBankDet() {
                this.api.bank = true;
                this.formBank.post('api/db-update-bank')
                    .then((response) => {
                        this.api.bank = false;
                        this.setStatusATT('ATT22');

                    })
                    .catch(error => {
                        this.api.bank = false;
                        console.log(error);
                    })
            },


            swalUpdateBank() {
                Swal.fire({
                    title: 'Success',
                    text: 'Proof of Bank/EMA successfully updated',
                    icon: 'success',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },
            swalUpdateCob() {
                Swal.fire({
                    title: 'Success',
                    text: 'Coborrower information successfully updated',
                    icon: 'success',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },

            syncUpdateBankDet: async function() {
                await this.submitBankDet();
                await this.postAttach();
                await $('#modalBank').modal('hide');
                await this.swalUpdateBank();
            },



            updateBankDet: _.debounce(function() {

                this.formBank.ATT22 = this.formATT.ATT22;
                this.formBank.notif_id = this.notif_id;



                this.submittedBank = true
                this.$v.formBank.$touch();
                if (this.$v.formBank.$invalid) {
                    this.requiredField();
                } else {
                    let val = this.formBank.acctno;
                    let digits = val.replace(/-|\s/g, "");
                    let manner_rel = this.formBank.manner_rel;
                    let loan_amount = this.formBank.req_loan_amt;

                    if (this.formBank.manner_rel == 'GC' || this.formBank.manner_rel == 'PM') {
                        this.formBank.bankname = null;
                    }
                    this.syncUpdateBankDet();
                }
            }, 200),


            uploadImage12(e) {

                let file = e.target.files[0];
                let reader = new FileReader();
                if (file && !this.fileImage.includes(file['type'])) {
                    this.invalidFileFormat();
                    this.formName.ATT12 = null;
                } else {
                    if (file) {
                        reader.onloadend = (file) => {
                            this.formName.ATT12 = reader.result; //passing data to model
                        }
                        reader.readAsDataURL(file);
                    }
                }

            },


            updateNameID() {


                this.submiitedProfile = true
                this.$v.formName.$touch();
                if (this.$v.formName.$invalid) {
                    this.requiredField();
                } else {
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonText: 'No',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.value) {
                            if (this.formName.expiry_date) {
                             let customDate = moment(this.formName.expiry_date, 'MM/DD/YYYY');
                             this.formName.s_expiry_date = customDate.format('YYYY-MM-DD');
                            }
                            if (this.formName.date_birth) {
                                let customDate = moment(this.formName.date_birth, 'MM/DD/YYYY');
                                this.formName.s_birthdate = customDate.format('YYYY-MM-DD');
                            }
                            if (this.formName.ATT12) {
                                this.upload.ATT12 = true;
                                const config = {
                                    headers: {
                                        'content-type': 'multipart/form-data',
                                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                                    },
                                    onUploadProgress: function(progressEvent) {
                                        this.progress.ATT12 = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                                    }.bind(this)

                                }
                                let formData = new FormData();
                                formData.append('application_id', this.application_id);
                                formData.append('borrower_id', this.borrower_id);
                                formData.append('ATT12', this.formName.ATT12);

                                axios.post('api/c3-db-update-gov-id', formData, config)
                                    .then(response => {
                                        this.upload.ATT12 = false;


                                        setTimeout(() => {

                                        this.updateProfile();

                                        },700);

                                    })
                                    .catch(error => {
                                        this.upload.ATT12 = false;
                                        console.log(error);
                                    })
                            }
                        }
                    })
                }
            },


            proceedUpdateProfile() {
                Swal.fire({
                    title: 'Success',
                    text: "Your record has been updated",
                    icon: 'success',
                    showCancelButton: false,
                }).then((result) => {
                    if (result) {
                        this.setStatusATT('ATT12');
                        $('#modalProfile').modal('hide');
                        Fire.$emit('UserUpdated');
                    }
                })
            },

            logout() {
                axios.post('/logout').then(response => {
                window.location.href = "/login";
                }).catch(error => {
                if(error.response.status === 419){
                    window.location.href = "/login";
                }
                });
            },



            updateProfile2() {
                this.api.update_profile = true;
                this.recordExist = false;


                if (this.formName.expiry_date) {
                    let customDate = moment(this.formName.expiry_date, 'MM/DD/YYYY');
                    this.formName.s_expiry_date = customDate.format('YYYY-MM-DD');
                }

                if (this.formName.date_birth) {
                    let customDate = moment(this.formName.date_birth, 'MM/DD/YYYY');
                    this.formName.s_birthdate = customDate.format('YYYY-MM-DD');
                }



                this.formName.post('api/db-update-profile')
                    .then((response) => {
                        this.api.update_profile = false;
                        let data = response.data.updateRecord;
                        this.duplicates = response.data.duplicate;
                        this.ids = response.data.ids;
                        

                        if (data == false) {
                            this.recordExist = true;
                            $('#modalProfile').modal('show');
                            
                        }
                        if (data == true) {
                            
                            this.setStatusATT('ATT12');
                            $('#modalProfile').modal('hide');
                            Fire.$emit('UserUpdated');

                            if(this.user.id == this.selectedAccount[0].user_id){
                                this.routeBack2();
                            }else{
                                Swal.fire({
                                    title: 'Success',
                                    text: "Your record has been updated.  The system will be logging you out. Kindly login to your account using the email address you have chosen.  Click \"Forgot my Email or Password?\" link and select \"I forgot my password\" if you have forgotten your password for chosen email address.",
                                    icon: 'success',
                                    showCancelButton: false,
                                }).then((result) => {
                                    if (result) {
                                        this.logout();
                                    }
                                })
                            }

                        }
                    })
                    .catch(error => {
                        this.api.update_profile = false;
                        console.log(error);
                    })
            },


            updateProfile() {
                this.api.update_profile = true;
                this.recordExist = false;

                // if (this.formName.expiry_date) {
                //     let customDate = moment(this.formName.expiry_date, 'MM/DD/YYYY');
                //     this.formName.s_expiry_date = customDate.format('YYYY-MM-DD');
                // }

                // if (this.formName.date_birth) {
                //     let customDate = moment(this.formName.date_birth, 'MM/DD/YYYY');
                //     this.formName.s_date_birth = customDate.format('YYYY-MM-DD');
                // }

                this.formName.post('api/db-update-profile')
                    .then((response) => {
                        this.api.update_profile = false;
                        let data = response.data.updateRecord;
                        this.duplicates = response.data.duplicate;
                        this.ids = response.data.ids;
                        

                        if (data == false) {
                            this.recordExist = true;
                            $('#modalProfile').modal('show');
                            
                        }
                        if (data == true) {
                            this.setStatusATT('ATT12');
                            $('#modalProfile').modal('hide');
                            Fire.$emit('UserUpdated');
                            this.routeBack2();
                        }
                    })
                    .catch(error => {
                        this.api.update_profile = false;
                        console.log(error);
                    })
            },


            syncUpdateCob: async function() {
                await this.postAttach();
                await this.updateCobDetails();
                await $('#modalCob').modal('hide');
                await this.swalUpdateCob();
            },


            updateCobDetails(){
                this.api.cob = true;
                this.formCob.post('api/db-update-cob')
                    .then((response) => {
                        this.api.cob = false;
                        this.setStatusATT('ATT29');
                    })
                    .catch(error => {
                        this.api.cob = false;
                        console.log(error);
                    })
            },

            updateCob: _.debounce(function() {
                this.formCob.application_id = this.application_id;
                this.formCob.borrower_id = this.borrower_id;
                this.formCob.notif_id = this.notif_id;
                this.formCob.ATT29 = this.formATT.ATT29;

                this.submittedCob = true
                this.$v.formCob.$touch();
                if (this.$v.formCob.$invalid) {
                    this.requiredField();
                } else {
                    this.syncUpdateCob();
                }
            }, 600),


            selectedMR() {
                this.formBank.bankname = "";
                this.formBank.acctno = "";
                this.formBank.acct_mobile = "";
            },

            // selectedBank() {
            //     let manner_rel = this.formBank.manner_rel;
            //     let bank = this.formBank.bankname
            //     if (manner_rel == 'FT' && bank == "LAND BANK OF THE PHILIPPINES") {
            //         Swal.fire({
            //             title: 'Reminder',
            //             html: 'For Fund Transfer (Landbank) – Account number should have <b>6 or 7 on the fourth digit of the account number.</b>',
            //             icon: 'warning',
            //             allowEscapeKey: false,
            //             allowOutsideClick: false,
            //             onAfterClose: () => {
            //                 this.$refs.acctno.focus();
            //             }
            //         })
            //         return;
            //     }

            // },

            getBanks() {
                if (this.data_banks.length == 0) {
                    axios.get('/api/banks')
                        .then(response => {
                            this.data_banks = response.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },

            getMannerRelease() {
                if (this.data_manner_rel.length == 0) {
                    axios.get('/api/manner-release2')
                        .then(response => {
                            this.data_manner_rel = response.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },
            getBankDetails() {
                this.api.bank = true;
                axios.get('api/db-bank-details', {
                        params: {
                            application_id: this.application_id,
                        }
                    })
                    .then((response) => {
                        this.api.bank = false;
                        if (response.data.length > 0) {
                            this.formBank.fill(response.data[0]);
                        }
                    })
                    .catch(error => {
                        this.api.bank = false;
                        console.log(error);
                    })
            },


            getBusinessName() {
                this.api.update = true;
                axios.get('api/db-business-name', {
                        params: {
                            borrower_id: this.borrower_id,
                            application_id: this.application_id,
                        }
                    })
                    .then((response) => {
                        this.api.update = false;
                        this.bus_info = response.data[0];
                        $('#modalBusiness').modal('show');
                    })
                    .catch(error => {
                        this.api.update = false;
                        console.log(error);
                    })
            },
            updateBusName: _.debounce(function() {
                this.formCob.application_id = this.application_id;
                this.formCob.notif_id = this.notif_id;

                this.submittedCob = true
                this.$v.bus_info.$touch();
                if (this.$v.bus_info.$invalid) {
                    this.requiredField();
                } else {
                    this.api.update = true;
                    axios.post('api/db-update-bus-name', {
                            borrower_id: this.borrower_id,
                            application_id: this.application_id,
                            business_name: this.bus_info.business_name,
                            bus_id: this.bus_info.id,
                            notif_id: this.notif_id,
                            doc_code: this.doc_code,
                            bt_code: this.bt_code,
                        })
                        .then((response) => {
                            this.api.update = false;
                            this.setStatusATT(this.business_file);
                            $('#modalBusiness').modal('hide');
                        })
                        .catch(error => {
                            this.api.update = false;
                            console.log(error);
                        })
                }
            }, 200),


            syncBankDetails: async function() {
                await this.getMannerRelease();
                await this.getBanks();
                await this.getBankDetails();
                await $('#modalBank').modal('show');
            },

            routeBack2() {
                this.update_profile = false;
                this.$router.push({
                    path: 'heroes-dashboard',
                    query: {
                        a: this.application_id,
                        b: this.borrower_id,
                        n: this.notif_id,
                    }
                })
            },

            routeUpdateProfile() {
                this.update_profile = true;
                this.$router.push({
                    path: 'heroes-dashboard',
                    query: {
                        a: this.application_id,
                        b: this.borrower_id,
                        n: this.notif_id,
                        u: this.update_profile
                    }
                })
            },

            getRefID() {
                if (this.data_IDtypes.length == 0) {
                    this.api.id_types = true;
                    axios.get('/api/type-of-id')
                        .then(response => {
                            this.api.id_types = false;
                            this.data_IDtypes = response.data
                            
                        })
                        .catch(error => {
                            this.api.id_types = false;
                        })
                }
            },


            editModal(e) {
                this.business_file = null;
                if (e == 'ATT12') {
                    this.uploadRRF = false;
                    this.recordExist = false;
                    this.formName.borrower_id = this.borrower_id;
                    this.formName.application_id = this.application_id;
                    this.formName.notif_id = this.notif_id;

                    this.formName.fname = this.formBorrower.fname;
                    this.formName.lname = this.formBorrower.lname;
                    this.formName.mname = this.formBorrower.mname;
                    this.formName.suffix_code = this.formBorrower.suffix_code;
                    this.formName.date_birth = this.formBorrower.date_birth;
                    this.formName.email = this.formBorrower.email;

                    this.formName.gender_id = this.formBorrower.gender_id;
                    this.formName.cs_code = this.formBorrower.cs_code;

                    this.formName.province_code_birth = this.formBorrower.province_code_birth;
                    this.formName.place_birth = this.formBorrower.place_birth;

                    this.formName.bt_code = this.bt_code;
                    if(this.formName.date_birth){ 
                        this.formName.date_birth = moment(this.formName.date_birth, "YYYY-MM-DD hh:mm:ss").format("MM/DD/YYYY");
                        this.date_birth = this.formName.date_birth;
                    }
                    this.getProvince();
                    this.getCity(this.formName.province_code_birth);
                    this.getRefID();
                    this.routeUpdateProfile();
                }
                if (e == 'ATT22') {
                    this.syncBankDetails();
                }
                if (e == 'ATT29') {
                    this.syncGetCobDetails();
                }

            },



            syncSave: async function(event) {
                await this.postAttach();
                Swal.fire({
                    icon: 'success',
                    // text: 'Successfully Saved.',
                    title: 'Saved!',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },
            saveTag() {
                this.syncSave();
            },



            resetObj(obj, val) {
                for (let k in obj) {
                    obj[k] = val;
                }
            },
            routeBack() {
                this.resetObj(this.formATT, null);
                this.resetObj(this.fetchATT, null);
                this.resetObj(this.labelATT, 'Choose a file...');
                this.resetObj(this.progress, 0);
                this.borrower_id = null;
                this.application_id = null;
                this.notif_id = null;
                this.for_settlement = false;
                this.$router.push('/heroes-dashboard');
                this.getBorrowerDetail();
            },


            compliedTag() {
                this.api.notif = true;
                axios.post('api/c3-db-update-dv', {
                        borrower_id: this.borrower_id,
                        application_id: this.application_id,
                        notif_id: this.notif_id,
                        for_settlement: this.for_settlement,
                    })
                    .then(response => {
                        this.api.notif = false;
                        Swal.fire({
                            icon: 'success',
                            text: 'You successfully complied',
                            title: 'Success',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result) {
                                this.routeBack();
                            }
                        })
                    }).catch(error => {
                        this.api.notif = false;
                    })
            },
            syncSubmit: async function(event) {
                await this.postAttach();

                if (this.notif_detail.some(obj => obj.status === "CS01")) {
                    Swal.fire({
                        icon: 'warning',
                        text: 'Please complete all for compliance before submitting',
                        title: 'Reminder',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                    })
                } else {
                    await this.compliedTag();
                }
            },
            submitTag() {
                this.syncSubmit();
            },
            postAttach: async function(event) {
                if (this.formATT.ATT12 && !this.fetchATT.ATT12) {
                    this.upload.ATT12 = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.progress.ATT12 = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                        }.bind(this)

                    }
                    let formData = new FormData();
                    formData.append('doc_code', 1);
                    formData.append('notif_id', this.notif_id);
                    formData.append('application_id', this.application_id);
                    formData.append('borrower_id', this.borrower_id);
                    formData.append('ATT12', this.formATT.ATT12);

                    await axios.post('api/db_att12', formData, config)
                        .then(response => {
                            this.upload.ATT12 = false;
                            this.fetchATT = Object.assign(this.fetchATT, response.data);

                            this.formATT.ATT12 = '';
                            this.setStatusATT('ATT12');
                        })
                        .catch(error => {
                            this.upload.ATT12 = false;
                            console.log(error);

                        })
                }
                if (this.formATT.ATT26 && !this.fetchATT.ATT26) {
                    this.upload.ATT26 = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.progress.ATT26 = parseInt(Math.round((progressEvent.loaded * 260) / progressEvent.total)) + '%';
                        }.bind(this)

                    }
                    let formData = new FormData();
                    formData.append('doc_code', 20);
                    formData.append('notif_id', this.notif_id);
                    formData.append('application_id', this.application_id);
                    formData.append('borrower_id', this.borrower_id);
                    formData.append('ATT26', this.formATT.ATT26);

                    await axios.post('api/db_att26', formData, config)
                        .then(response => {
                            this.upload.ATT26 = false;
                            this.fetchATT = Object.assign(this.fetchATT, response.data);

                            this.formATT.ATT26 = '';
                            this.setStatusATT('ATT26');
                        })
                        .catch(error => {
                            this.upload.ATT26 = false;
                            console.log(error);
                        })
                }
                if (this.formATT.ATT27 && !this.fetchATT.ATT27) {
                    this.upload.ATT27 = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.progress.ATT27 = parseInt(Math.round((progressEvent.loaded * 270) / progressEvent.total)) + '%';
                        }.bind(this)

                    }
                    let formData = new FormData();
                    formData.append('doc_code', 21);
                    formData.append('notif_id', this.notif_id);
                    formData.append('application_id', this.application_id);
                    formData.append('borrower_id', this.borrower_id);
                    formData.append('ATT27', this.formATT.ATT27);

                    await axios.post('api/db_att27', formData, config)
                        .then(response => {
                            this.upload.ATT27 = false;
                            this.fetchATT = Object.assign(this.fetchATT, response.data);

                            this.formATT.ATT27 = '';
                            this.setStatusATT('ATT27');
                        })
                        .catch(error => {
                            this.upload.ATT27 = false;
                            console.log(error);
                        })
                }
                if (this.formATT.ATT28 && !this.fetchATT.ATT28) {
                    this.upload.ATT28 = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.progress.ATT28 = parseInt(Math.round((progressEvent.loaded * 280) / progressEvent.total)) + '%';
                        }.bind(this)

                    }
                    let formData = new FormData();
                    formData.append('doc_code', 22);
                    formData.append('notif_id', this.notif_id);
                    formData.append('application_id', this.application_id);
                    formData.append('borrower_id', this.borrower_id);
                    formData.append('ATT28', this.formATT.ATT28);

                    await axios.post('api/db_att28', formData, config)
                        .then(response => {
                            this.upload.ATT28 = false;
                            this.fetchATT = Object.assign(this.fetchATT, response.data);

                            this.formATT.ATT28 = '';
                            this.setStatusATT('ATT28');
                        })
                        .catch(error => {
                            this.upload.ATT28 = false;
                            console.log(error);
                        })
                }


                if (this.formATT.DOC01 && !this.fetchATT.DOC01) {
                    this.upload.DOC01 = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.progress.DOC01 = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                        }.bind(this)

                    }
                    let formData = new FormData();
                    formData.append('doc_code', 18);
                    formData.append('notif_id', this.notif_id);
                    formData.append('application_id', this.application_id);
                    formData.append('borrower_id', this.borrower_id);
                    formData.append('DOC01', this.formATT.DOC01);

                    await axios.post('api/db_attdoc01', formData, config)
                        .then(response => {
                            this.upload.DOC01 = false;
                            this.fetchATT = Object.assign(this.fetchATT, response.data);

                            this.formATT.DOC01 = '';
                            this.setStatusATT('DOC01');

                            this.for_settlement = true;
                        })
                        .catch(error => {
                            this.upload.DOC01 = false;
                            console.log(error);
                        })
                }

                if (this.formATT.ATT22 && !this.fetchATT.ATT22) {
                    this.upload.ATT22 = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            this.progress.ATT22 = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                        }.bind(this)

                    }
                    let formData = new FormData();
                    formData.append('doc_code', 25);
                    formData.append('notif_id', this.notif_id);
                    formData.append('application_id', this.application_id);
                    formData.append('borrower_id', this.borrower_id);
                    formData.append('ATT22', this.formATT.ATT22);

                    await axios.post('api/db_att22', formData, config)
                        .then(response => {
                            this.upload.ATT22 = false;
                            this.fetchATT = Object.assign(this.fetchATT, response.data);

                            this.formATT.ATT22 = '';
                            this.setStatusATT('ATT22');
                        })
                        .catch(error => {
                            this.upload.ATT22 = false;
                            console.log(error);
                        })
                }


            },



            notifURL(n) {
                this.notif_id = n.id;
                this.borrower_id = n.borrower_id;
                this.application_id = n.application_id;
                this.subj_id = n.subj_id;

                if(this.subj_id == 1)
                {
                    this.$router.push({
                        path: 'heroes-dashboard',
                        query: {
                            a: n.application_id,
                            b: n.borrower_id,
                            n: n.id
                        }
                    })
                    this.getNotifDetails(n.id, n.borrower_id, n.application_id);
                 
                }
                else if(this.subj_id == 2 || this.subj_id == 3){
                    this.$router.push('/loan-releasing');
                }
                else{
                    return;
                }

            },

            getNotifDetails(id, borrower_id, application_id) {
                if (id && borrower_id) {
                    this.api.notif = true;
                    axios.get("api/c3-notif-details", {
                            params: {
                                id: id,
                                borrower_id: borrower_id,
                                application_id: application_id
                            }
                        })
                        .then(response => {
                            this.api.notif = false;
                            this.notif_detail = response.data.details;
                            this.bt_code = response.data.bus_type[0].bt_code;
                            this.initToggling();
                        })
                        .catch(error => {
                            this.api.notif = false;
                            console.log(error);
                        });
                }
            },


            getNotif(id) {
                this.api.notif = true;
                axios.get("api/c3-notif", {
                        params: {
                            borrower_id: id
                        }
                    })
                    .then(response => {
                        this.api.notif = false;
                        this.notif = response.data;
                        this.initToggling();
                    })
                    .catch(error => {
                        this.api.notif = false;
                        console.log(error);
                    });
            },

            syncGetCobDetails: async function (){
                await this.getRefID();
                await this.getCoborrowerRelation();
                await this.getCoborrowerInfo();
            },

            getCoborrowerInfo(){
                this.api.cob = true;
                    axios.get('api/db-cob-details', {
                            params: {
                                borrower_id: this.borrower_id,
                            }
                        })
                        .then((response) => {
                            this.api.cob = false;
                            if (response.data.length > 0) {
                                this.formCob.fill(response.data[0]);
                                setTimeout(() => {
                                    $('#modalCob').modal('show');
                                }, 300);
                            }else
                            {
                                setTimeout(() => {
                                    $('#modalCob').modal('show');
                                }, 300);
                            }
                        })
                        .catch(error => {
                            this.api.cob = false;
                            console.log(error);
                        })
            },
            getCoborrowerRelation() {
                if (this.data_relation.length == 0) {
                axios.get('/api/coborrower-relation')
                    .then(response => {
                        this.data_relation = response.data
                    })
                    .catch(error => {
                        console.log(error);
                    })
                }
            },

            getTransact(id) {
                this.api.transact = true;
                axios.get("api/c3-transact", {
                        params: {
                            borrower_id: id
                        }
                    })
                    .then(response => {
                        this.api.transact = false;

                        this.transact = response.data;
                    })
                    .catch(error => {
                        this.api.transact = false;
                        console.log(error);
                    });
            },

            getUser() {
                this.api.user = true;
                axios.get("api/user")
                    .then(response => {
                        this.api.user = false;
                        this.user.fill(response.data);
                        this.getBorrowerDetail();
                        this.getExistLoan();
                    })
                    .catch(error => {
                        this.api.user = false;
                        console.log(error);
                    });
            },
            getLoanAppForm(id) {
                this.api.form = true;
                axios.get("api/db-app-form", {
                        params: {
                            borrower_id: id
                        }
                    })
                    .then(response => {
                        this.api.form = false;
                        if (response.data) {
                            this.appForm.fill(response.data);
                        }

                    })
                    .catch(error => {
                        this.api.form = false;
                        console.log(error);
                    });
            },

            getBorrowerDetail() {
                this.api.bor_det = true;
                axios.get("api/c3-bor-profile")
                    .then(response => {
                        this.api.bor_det = false;
                        if (response.data.length > 0) {
                            this.formBorrower.fill(response.data[0]);


                            setTimeout(() => {
                                this.getLoanAppForm(this.formBorrower.borrower_id);
                                this.getNotif(this.formBorrower.borrower_id);
                                this.getTransact(this.formBorrower.borrower_id);
                                this.getAttachLR(this.formBorrower.borrower_id);
                            }, 500);

                        }
                    })
                    .catch(error => {
                        this.api.bor_det = false;
                        console.log(error);
                    });
            },
        },

        created() {
            this.getUser();
            this.getNotifDetails(this.notif_id, this.borrower_id, this.application_id)
        },
        mounted() {},

        computed: {

            borrowerName(){
                let name;
                let fname = this.formBorrower.fname;
                let mname = this.formBorrower.mname;
                let lname = this.formBorrower.lname;

                let suffix = this.formBorrower.suffix_desc;
                if(suffix)
                {
                    name = fname + ' ' + mname + lname + ' ' + suffix;
                }
                else
                {
                    name = fname + ' ' + mname + ' ' + lname;
                }
                return name;
            },

            processingAPI() {
                return Object.values(this.api).includes(true);
            },

            uploadingAPI() {
                return Object.values(this.upload).includes(true);
            },
            filteredMR() {
                let list = this.data_manner_rel;
                let amount = this.formBank.req_loan_amt;
                let filter = null;
                if (amount > 50000) {
                    filter = list.filter(function(item) {
                        return item.manner_rel_code == 'FT' || item.manner_rel_code == 'PN';
                    });
                    return filter;
                } else if (amount <= 30000) {
                    return list;
                } else {
                    filter = list.filter(function(item) {
                        return item.manner_rel_code == 'FT' || item.manner_rel_code == 'PN' || item.manner_rel_code == 'IP';
                    });
                    return filter;
                }
            },
            filteredBank() {
                let data_banks = this.data_banks;
                if (this.formBank.manner_rel == "IP") {
                    let instapay_data = data_banks.filter(function(item) {
                        return item.instapay == 'Y';
                    });
                    return instapay_data;
                }

                if (this.formBank.manner_rel == "PN") {
                    let pesonet_data = data_banks.filter(function(item) {
                        return item.pesonet == 'Y';
                    });
                    return pesonet_data;
                }

                if (this.formBank.manner_rel == "FT") {
                    let bankname = [{
                        'bankname': 'LAND BANK OF THE PHILIPPINES'
                    }];
                    return bankname;
                }
                if (this.formBank.manner_rel == "CC") {
                    let ft_data = data_banks.filter(function(item) {
                        return item.bankname == 'LAND BANK OF THE PHILIPPINES';
                    });
                    return ft_data;
                }
            },

        },


    }
</script>





<style>
    .btn-block {
        display: block;
        width: 100%;

    }

    .btn-info {
        color: #fff;
        background-color: #28a745;
        border-color: #28a745;
        cursor: pointer;
        margin: 0%;
        padding-bottom: 0;
    }

    .btn-info:hover {
        background-color: darkgreen;
        cursor: pointer;
    }

    .cursor {
        cursor: pointer;
    }

    .container-iframe {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .responsive-iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }


    #overlay {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        align-items: center;
        display: flex;
        justify-content: center;
        overflow: visible;
        z-index: 9999;
        position: fixed;
        background-color: rgba(255, 255, 255, 0.5);
        /* background-color: black; */
    }


    .spinner {
        position: fixed;
        height: 60px;
        width: 60px;
        border: 3px solid transparent;
        border-top-color: #f96f14;
        margin: auto;
        border-radius: 50%;
        animation: spin 2s linear infinite;
    }

    .spinner:before,
    .spinner:after {
        content: '';
        position: fixed;
        border: 3px solid transparent;
        border-radius: 50%;
    }

    .spinner:before {
        border-top-color: #39cc78;
        top: -12px;
        left: -12px;
        right: -12px;
        bottom: -12px;
        animation: spin 3s linear infinite;
    }

    .spinner:after {
        border-top-color: black;
        top: 6px;
        left: 6px;
        right: 6px;
        bottom: 6px;
        animation: spin 4s linear infinite;
    }


    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    .spinner.hidden {
        animation: fadeOut 1s;
        animation-fill-mode: forwards;
    }

    @keyframes fadeOut {
        100% {
            opacity: 0;
            visibility: hidden;
        }
    }

    label {
        font-weight: 400 !important;
    }


    @media (min-width: 1px) and (max-width: 767.98px) {
        .mobile_mode {
            display: block !important;
        }

        .h-title {
            font-size: 20px;
        }
    }


    /*Desktop, Laptop screen*/
    @media only screen and (min-width: 768px) {
        .desktop_mode {
            display: block !important;
        }

        object {
            min-height: 75vh !important;
        }

        .h-title {
            font-size: 28px;
        }
    }
</style>